module.exports = __webpack_public_path__ + "3ca91c9e04989d4eca18efa5621f0fcf.pdf";